import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectOptedOutNotifications } from '../../../selectors/notificationSelectors';

import NotificationSettings from './NotificationSettings/NotificationSettings';

import styles from './AccountNotification.module.scss';

const AccountNotification = () => {
  const { t } = useTranslation('common');
  const optOutNotifications = useSelector(selectOptedOutNotifications);
  return (
    <div className={styles.containerWidth}>
      <div className={styles.container}>
        {optOutNotifications.includes('account_management_sms') ? (
          <div className={styles.contentBlock}>
            <div className={styles.optOutText}>{t('notificationSettings.optOutMessage')}</div>
          </div>
        ) : null}
        <div className={styles.contentBlockNotificationSettings}>
          <NotificationSettings />
        </div>
      </div>
    </div>
  );
};

export default AccountNotification;
